/* sections/maido-hero.liquid — the campaign hero (HB-02).
 *
 * The carousel itself is Dawn's: <maido-hero> extends SlideshowComponent, so
 * scrolling, the dots, the arrows, looping and slide visibility are the theme's
 * tested behaviour and stay in step with it. Two things are added here that the
 * blueprint requires and Dawn does not do:
 *
 *   1. Reduced motion. SlideshowComponent honours `prefers-reduced-motion` only
 *      on the branch it takes when no autoplay button is present — a branch this
 *      hero cannot take, because that same branch reads `this.reducedMotion`,
 *      which the base class only assigns for announcement bars. With the button
 *      rendered, the base class always calls play(). So rotation is started by
 *      super and immediately toggled off here when reduce is asked for.
 *
 *   2. A permanent stop on first interaction. Dawn pauses while a control has
 *      focus and resumes on focusout. Once anyone deliberately moves the hero,
 *      it should stay where they put it.
 *
 * Both are expressed through autoPlayToggle() rather than pause(), because the
 * toggle is what flips `autoplayButtonIsSetToPlay` — and that flag is the one
 * thing focusOutHandling() checks before resuming. Calling pause() alone would
 * stop rotation only until the next blur.
 *
 * This file is loaded with `defer`, so it runs after the deferred global.js in
 * which SlideshowComponent is defined.
 */
if (typeof SlideshowComponent !== 'undefined' && !customElements.get('maido-hero')) {
  class MaidoHero extends SlideshowComponent {
    setAutoPlay() {
      // Assigned before super so the no-button branch cannot throw if a future
      // edit stops rendering the autoplay control.
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      super.setAutoPlay();

      if (!this.sliderAutoplayButton) return;

      if (this.reducedMotion.matches) this.stopAutoplayForGood();

      this.reducedMotion.addEventListener('change', (event) => {
        if (event.matches) this.stopAutoplayForGood();
      });

      const controls = [this.prevButton, this.nextButton, ...this.sliderControlLinksArray];
      controls.forEach((control) => {
        if (!control) return;
        control.addEventListener('click', () => this.stopAutoplayForGood(), { once: true });
      });
    }

    stopAutoplayForGood() {
      // autoPlayToggle() is a toggle: calling it while already stopped would
      // start rotation again.
      if (!this.autoplayButtonIsSetToPlay) return;
      this.autoPlayToggle();
    }
  }

  customElements.define('maido-hero', MaidoHero);
}
